var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"item",attrs:{"id":_vm.id},on:{"click":_vm.routeToList}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }